import { Header, Footer } from '@/components/layout'
import { Industries } from '@/components/sections'
import { SEO } from '@/components/seo'

export default function IndustriesPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Industries"
        description="Ledger works for tea shops, grocers, tailors, vendors, restaurants, farmers, freelancers, and accounting firms across Sri Lanka."
        canonical="/industries"
      />
      <Header />
      <main className="pt-16">
        <Industries />
      </main>
      <Footer />
    </div>
  )
}

